import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useAdmnistrativeAreasQuery } from '../queries/__generated__/administrativeAreas.generated';
import { administrativeAreasAtom } from '../administrativeAreas/state';

export default function useAdministrativeAreas(): void {
  const { data, loading } = useAdmnistrativeAreasQuery();
  const setAdministrativeAreasAtom = useSetAtom(administrativeAreasAtom);

  useEffect(() => {
    if (!loading) {
      setAdministrativeAreasAtom(data?.administrative_area || []);
    }
  }, [loading]);
}
